import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnInit,
  SimpleChange,
  SimpleChanges,
  inject,
  input,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { Basket } from 'ish-core/models/basket/basket.model';
import { SuccessMessageComponent } from 'ish-shared/components/common/success-message/success-message.component';

/**
 * The Basket Merchant Message Component displays a message to merchant input.
 * It provides the add message to merchant functionality.
 *
 */
@Component({
  selector: 'ish-basket-merchant-message',
  templateUrl: './basket-merchant-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ReactiveFormsModule, SuccessMessageComponent, FormlyModule, TranslateModule],
})
export class BasketMerchantMessageComponent implements OnInit, OnChanges {
  private checkoutFacade = inject(CheckoutFacade);
  private cd = inject(ChangeDetectorRef);

  readonly basket = input.required<Basket>();
  readonly multiPageCheckout = input<boolean>(false);

  form = new FormGroup({});
  model: { messageToMerchant: string } = { messageToMerchant: '' };
  fields: FormlyFieldConfig[];
  showSuccessMessage = false;

  ngOnInit() {
    this.fields = [
      {
        key: 'messageToMerchant',
        type: 'ish-textarea-field',
        props: {
          label: 'checkout.basket_merchant_message.label',
          maxLength: 1000,
          rows: 2,
          labelClass: 'col-md-12',
          fieldClass: 'col-md-12',
        },
      },
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    const basket = this.basket();
    if (basket) {
      this.successMessage(changes.basket);
      this.model = {
        ...this.model,
        messageToMerchant: basket?.messageToMerchant ? basket?.messageToMerchant : '',
      };
    }
  }

  private successMessage(basketChange: SimpleChange) {
    if (
      basketChange?.previousValue?.messageToMerchant !== basketChange?.currentValue?.messageToMerchant &&
      !basketChange?.firstChange
    ) {
      this.showSuccessMessage = true;
      setTimeout(() => {
        this.showSuccessMessage = false;
        this.cd.markForCheck();
      }, 5000);
    }
  }

  get disabled() {
    return !this.basket()?.messageToMerchant && !this.form.get('messageToMerchant')?.value;
  }

  submitForm(): void {
    this.checkoutFacade.setBasketMessageToMerchant(this.form.get('messageToMerchant')?.value);
  }
}
